<!--
 * @Author: xiaokun
 * @Date: 2020-06-09 10:51:58
 * @LastEditors: xiaokun
 * @LastEditTime: 2020-06-19 15:02:32
 * @Description: 统计信息-销售参与统计-员工执行情况
-->
<template>
  <div class="sale-execute-condition">
    <div class="header">
      <div class="title">
        员工执行情况
      </div>
      <div class="btn">
        <mk-radio-group
          v-model="curSelect"
          size="mini"
        >
          <mk-radio-button
            v-for="item in tabs"
            :key="item"
            :label="item"
          />
        </mk-radio-group>
      </div>
    </div>
    <execute-condition v-if="curSelect==='执行情况'" />
    <execute-result v-else />
  </div>
</template>
<script>
import ExecuteResult from './execute-result'
import ExecuteCondition from './execute-condition'
export default {
  name: 'SaleExecuteCondition',
  components: { ExecuteResult, ExecuteCondition },
  props: {},
  data () {
    return {
      curSelect: '执行情况',
      tabs: ['执行情况', '执行效果']
    }
  },
  watch: {},
  created () {
  },
  mounted () {},
  methods: {

  }
}
</script>
<style lang='scss' scoped>
.sale-execute-condition {
  width: 360px;
  height: 545px;
  flex-shrink: 0;
  border: 1px solid #e8e8e8;
  margin-top: 20px;
  overflow: hidden;

  .header {
    padding: 12px 10px 12px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e8e8e8;

    .title {
      color: #262626;
      font-size: 14px;
      line-height: 20px;
      font-weight: 500;
    }

    /deep/ .mk-radio-group {
      .is-active {
        .el-radio-button__inner {
          color: #009cff;
        }
      }

      .el-radio-button__inner {
        background-color: #fff;
      }
    }
  }
}
</style>
